(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pk-welcome"] && !Shopify.designMode) return;
  try {
    
function setupPkWelcome(){document.querySelectorAll('.pk-welcome').forEach(dialog=>{if(dialog.dataset.ready)return;dialog.dataset.ready='true';const close=()=>{dialog.close();try{sessionStorage.setItem('pkWelcomeSeen','1')}catch{}};dialog.querySelector('.pk-welcome__close').addEventListener('click',close);dialog.querySelector('.pk-welcome__later').addEventListener('click',close);dialog.addEventListener('cancel',close);let seen=false;try{seen=sessionStorage.getItem('pkWelcomeSeen')==='1'}catch{}if(!seen&&!window.Shopify?.designMode)setTimeout(()=>{if(!document.querySelector('dialog[open]')){dialog.showModal();try{sessionStorage.setItem('pkWelcomeSeen','1')}catch{}}},18000)})}setupPkWelcome();document.addEventListener('shopify:section:load',setupPkWelcome);

  } catch(e) { console.error(e); }
})();
})();
